module.exports = __webpack_public_path__ + "img/share_bg.02a2cf43.jpg";